import LandingFooter from '@/components/LandingFooter.tsx'
import LandingHeader from '@/components/LandingHeader.tsx'
import { languageBasedOnTimezone } from '@/utils/language.ts'
import { useEffect } from 'react'
import styles from './PolicyPage.module.scss'

export const CookiePolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <div className={styles.policyContainer}>
        <div className={styles.topSection}>
          <LandingHeader language={languageBasedOnTimezone()} selectLanguageEnabled={false} />
        </div>
        <div className={styles.contentsSection}>
          <div className={styles.titleContainer}>
            <h1>COOKIE POLICY</h1>
            <div className={styles.dates}>Effective Date: February 23, 2025</div>
            <div className={styles.dates}>Last Updated: April 24, 2025</div>
            <div>
              <p>
                This Cookie Policy explains how Bekind Labs LLC (”Bekind Labs,” “we,” “us,” or “our”) uses cookies and
                similar tracking technologies on our website
                <a href="https://trackerboot.com">&nbsp;https://trackerboot.com</a> (the “Service”). These technologies
                help us understand how you interact with the Service, improve performance, and personalize your
                experience. We may also use cookies in collaboration with trusted third-party partners, such as
                analytics or advertising providers. This policy should be read in conjunction with our
                <a href="https://trackerboot.com/policies/privacy-policy">&nbsp;Privacy Policy</a>, which provides
                further information on how we collect, use, and safeguard your personal data.
              </p>
            </div>
          </div>
          <div className={styles.contentsContainer}>
            <h2>1. Purpose of Cookies</h2>
            <p>
              We use cookies to enhance your experience and optimize site performance on Tracker Boot. Cookies allow us
              to learn how users interact with our Services so that we can improve functionality and provide relevant
              content based on user behavior.
            </p>
          </div>
          <div className={styles.contentsContainer}>
            <h2>2. Types of Cookies We Use</h2>
            <h3>Essential Cookies</h3>
            <ul>
              <li>
                These cookies are necessary to provide essential services through both our website (trackerboot.com) and
                the Tracker Boot product. They enable secure browsing, support core site functionality, and remember
                your cookie preferences. For example, they help authenticate users, maintain secure sessions, and
                prevent fraudulent use of accounts. These cookies may include basic technical identifiers such as your
                IP address or browser type, which are used solely to ensure secure and reliable access. Without these
                cookies, key features of the website and product would not function properly.
              </li>
            </ul>
            <h3>Analytics & Performance Cookies</h3>
            <ul>
              <li>
                These cookies help us monitor the technical performance of the Tracker Boot product using tools such as
                Google Analytics, and Sentry. They collect anonymous metrics related to usage patterns and system
                behavior to help us improve the service. No personally identifiable information is collected for
                analytics purposes. These cookies are primarily set when users actively interact with the Tracker Boot
                application.
              </li>
            </ul>
          </div>
          <div className={styles.contentsContainer}>
            <h2>3. Purpose of Cookie Usage</h2>
            <ul>
              <li>• To Ensure Core Functionality: Maintaining essential website features.</li>
              <li>• To Analyze User Behavior: Understanding interactions to enhance usability.</li>
              <li>• To Maintain Performance: Monitoring site performance.</li>
            </ul>
          </div>
          <div className={styles.contentsContainer}>
            <h2>4. Third-Party Cookies</h2>
            <p>
              Some pages on our Service may include third-party cookies from service providers, such as analytics or
              monitoring partners. These cookies are governed by third-party policies, and separate consent may be
              required depending on jurisdiction. Please refer to the respective third-party privacy policies for more
              details.
            </p>
          </div>
          <div className={styles.contentsContainer}>
            <h2>5. Managing & Disabling Cookies</h2>
            <p>You can control or delete cookies through your browser settings. Most browsers allow you to:</p>
            <ul>
              <li>• Block all cookies</li>
              <li>• Delete existing cookies</li>
              <li>• Set cookie preferences for specific websites</li>
            </ul>
            <p>
              Additionally, you can manage your cookie preferences via the Customize Cookie Settings pop-up. If you
              choose to disable cookies, please note that certain features of our Service may not function properly.
              Essential Cookies cannot be disabled, as they are required for core functionality and security.
            </p>
            <p>
              For detailed instructions on how to adjust your cookie settings, please refer to the “Cookie Settings”
              link in the website footer or your browser’s help documentation.
            </p>
          </div>
          <div className={styles.contentsContainer}>
            <h2>6. Legal Basis for Using Cookies</h2>
            <p>
              Depending on applicable data protection laws (e.g., GDPR, Japan’s APPI, Korea’s PIPA), we may be required
              to obtain your consent before storing non-essential cookies on your device.
            </p>
            <p>
              By continuing to use our Service, you consent to the use of cookies as described in this policy, unless
              you have disabled cookies via your settings. You may withdraw your consent at any time by adjusting your
              preferences.
            </p>
          </div>
          <div className={styles.contentsContainer}>
            <h2>7. Changes to Our Cookie Policy</h2>
            <p>
              We may update this Cookie Policy periodically to reflect changes in our practices or regulatory
              requirements. When updates are made, we will revise the “Last Updated” date at the top of this policy.
            </p>
          </div>
          <div className={styles.contentsContainer}>
            <h2>
              8. Your Rights Under the California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA)
            </h2>
            <p>
              For visitors in the United States, particularly those in California, we may use Non-Essential Cookies that
              result in the sharing of Personal Information with third parties (e.g., analytics providers). Under the
              CCPA/CPRA, such use may be considered “sharing” of your Personal Information. We do not sell your Personal
              Information. However, you may opt out of such sharing by disabling Analytics & Performance Cookies through
              our Customize Cookies settings pop-up. For more details on how we collect, use, and share Personal
              Information and your rights under applicable laws, please refer to our Privacy Policy available at
              <a href="https://trackerboot.com/policies/privacy-policy">
                &nbsp;https://trackerboot.com/policies/privacy-policy
              </a>
              .
            </p>
          </div>
          <div className={styles.contentsContainer}>
            <h2>9. Contact Us</h2>
            <p>
              If you have any questions regarding this Cookie Policy, please contact us at
              <a href={'mailto:"trackerboot@bekindlabs.com"'}>&nbsp;trackerboot@bekindlabs.com</a>.
            </p>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  )
}
